var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 178,
    height: 118,
    rx: 7,
    fill: "white",
    stroke: "url(#paint0_linear_455_7648)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 52.5H92C92.2761 52.5 92.5 52.7239 92.5 53V57C92.5 57.2761 92.2761 57.5 92 57.5H85V52.5ZM70 57.5H60V62.5H70V57.5ZM120 57.5H110V62.5H120V57.5ZM92 62.5H85V67.5H92C92.2761 67.5 92.5 67.2761 92.5 67V63C92.5 62.7239 92.2761 62.5 92 62.5Z",
    fill: "#8790A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 65V62.5V60V57.5V55C70 53.0109 70.7902 51.1032 72.1967 49.6967C73.6032 48.2902 75.5109 47.5 77.5 47.5H85V52.5V57.5V62.5V67.5V72.5H77.5C75.5109 72.5 73.6032 71.7098 72.1967 70.3033C70.7902 68.8968 70 66.9891 70 65ZM107.803 70.3033C106.397 71.7098 104.489 72.5 102.5 72.5H95V47.5H102.5C104.489 47.5 106.397 48.2902 107.803 49.6967C109.21 51.1032 110 53.0109 110 55V57.5V62.5V65C110 66.9891 109.21 68.8968 107.803 70.3033Z",
    fill: "#8790A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_7648",
    x1: 0,
    y1: 59.9997,
    x2: 180,
    y2: 59.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#1099FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40796,
    stopColor: "#42EEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FFD159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FF8731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15E77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.c906a1d9fd11ce73490e180dd12b2b2d.svg";
export { ForwardRef as ReactComponent };